import React from "react";
import "./Header.css";
import PersonIcon from "@material-ui/icons/Person";
import MessageIcon from "@material-ui/icons/Message";
import { IconButton } from "@material-ui/core";
import {Link , useHistory} from "react-router-dom";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

function Header({backButton}) {

    const history = useHistory();


    return (
        <div className="header">
            { backButton ? (
                <IconButton onClick={()=> history.replace(backButton)}>
                <ArrowBackIcon fontSize="large" className="header__icon" />
                </IconButton>
                ) : (
            <IconButton>
                <PersonIcon fontSize="large" className="header__icon" />
            </IconButton>
                )}
            <IconButton>
            <Link to="/">
                <img
                    className="header__logo"
                    src="https://uxwing.com/wp-content/themes/uxwing/download/10-brands-and-social-media/tinder.png"
                    alt="Logo"
                />
                </Link>
            </IconButton>
            
            <Link to="/chat">
            <IconButton>
                <MessageIcon />
            </IconButton>
            </Link>
            
        </div>
    );
}

export default Header;
